export const GET_ADMINPORTALALERT_ABORTED = 'GET_ADMINPORTALALERT_ABORTED';
export const GET_ADMINPORTALALERT_REQUESTED = 'GET_ADMINPORTALALERT_REQUESTED';
export const GET_ADMINPORTALALERT_COMPLETED = 'GET_ADMINPORTALALERT_COMPLETED';
export const GET_ADMINPORTALALERT_FAILED = 'GET_ADMINPORTALALERT_FAILED';

export const SET_ADMINPORTALALERT_REQUESTED = 'SET_ADMINPORTALALERT_REQUESTED';
export const SET_ADMINPORTALALERT_COMPLETED = 'SET_ADMINPORTALALERT_COMPLETED';
export const SET_ADMINPORTALALERT_FAILED = 'SET_ADMINPORTALALERT_FAILED';
